<template>
  <v-overlay v-model="openedDialog" :opacity="0.92">
    <v-dialog v-model="openedDialog" content-class="CarouselModal" hide-overlay persistent>
      <v-carousel
        ref="vCarousel"
        v-model="activeItemIndex"
        :cycle="false"
        height="100%"
        hide-delimiters
        :show-arrows="!isMinimalistic"
      >
        <div class="closeButton" @click="openedDialog = false">
          <v-icon medium>close</v-icon>
          <span>{{ $t('popup_close') }}</span>
        </div>
        <SlideCounter v-if="!isMinimalistic">{{ activeItemIndex + 1 }}/{{ itemsLength }}</SlideCounter>
        <v-carousel-item
          v-for="(item, index) in gallery"
          :key="index"
          :reverse-transition="transitionType"
          :transition="transitionType"
        >
          <div v-if="item.video" class="slideGallery">
            <div :ref="`gallery_item_${item.gallery_item_id}`"
                 class="item_container"
                 :class="{ 'lightbox-resp': mode === 'lightbox_resp' }"
                 @click="closeOnClickedOut">
              <div class="video_wrap"
                   :class="{ 'lightbox-resp': mode === 'lightbox_resp' }"
                   @click="closeOnClickedOut"
                   @scroll="videoScroll">
                <iframe
                  :src="getCdn(item.video)"
                  :class="{ 'lightbox-resp': mode === 'lightbox_resp' }"
                  allow="autoplay; fullscreen"
                  allowfullscreen
                  frameborder="0"
                  style="position:absolute;top:0;left:0;width:100%;height:100%;"
                ></iframe>
              </div>
              <div v-if="item.caption" class="image_caption video">
                <div>{{ item.caption }}</div>
              </div>
            </div>
          </div>
          <div v-else-if="item.image" class="slideGallery">
            <div class="item_container" @click="closeOnClickedOut">
              <div class="image_wrap" @click="closeOnClickedOut">
                <img :src="getCdn(item.image)"/>
              </div>
            </div>
            <div v-if="item.caption" class="image_caption">
              <div>{{ item.caption }}</div>
            </div>
          </div>
        </v-carousel-item>
      </v-carousel>
    </v-dialog>
  </v-overlay>
</template>

<script>
import { cdnUrl } from '@/utils/urls';
import SlideCounter from './SlideCounter.vue';

export default {
  props: {
    gallery: {
      type: Array,
      required: true,
    },
    isMinimalistic: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      openedDialog: false,
      transitionType: 'fade',
      activeItemIndex: 0,
      mode: null,
    };
  },
  components: {
    SlideCounter,
  },
  mounted() {
    this.navigateWithKeyboard = this.navigateWithKeyboard.bind(this);

    document.addEventListener('keydown', this.navigateWithKeyboard);
  },
  destroyed() {
    document.removeEventListener('keydown', this.navigateWithKeyboard);
  },
  methods: {
    navigateWithKeyboard(event) {
      if (!this.openedDialog) {
        return;
      }
      if (event.code === 'Escape') {
        this.openedDialog = false;
      } else if ((event.code === 'ArrowUp' || event.code === 'ArrowRight') && !this.isMinimalistic) {
        this.activeItemIndex++;
        event.preventDefault();
      } else if ((event.code === 'ArrowDown' || event.code === 'ArrowLeft') && !this.isMinimalistic) {
        if (this.activeItemIndex <= 0) {
          this.activeItemIndex = this.gallery.length - 1;
        } else {
          this.activeItemIndex--;
        }
        event.preventDefault();
      }
    },
    openOnIdx(index, mode = null) {
      this.activeItemIndex = index;
      this.openedDialog = true;
      this.mode = mode;
      this.$emit('overlay-opened');
    },
    closeOnClickedOut(e) {
      const clickedOut = e.target.classList.contains('item_container') || e.target.classList.contains('video_wrap') ||
        e.target.classList.contains('image_wrap');
      if (clickedOut) this.openedDialog = false;
    },
    videoScroll(e) {
      e.target.scrollTo(0, 1);
    },
    touchVideoScroll(action) {
      this.$emit('video-scroll', action);
    },
    getCdn(source) {
      return cdnUrl(source);
    },
  },
  watch: {
    activeItemIndex(newCarouselItemIdx, oldCarouselItemIdx) {
      const videoIframes = document.querySelectorAll('.video_wrap iframe');
      if (videoIframes.length && this.gallery[newCarouselItemIdx].video) {
        videoIframes.forEach(videoIframe => videoIframe.src = this.gallery[newCarouselItemIdx].video);
      } else if (videoIframes.length) {
        videoIframes.forEach(videoIframe => videoIframe.src = '');
      }
    },
    openedDialog(newVal) {
      if (!newVal) {
        this.$emit('overlay-closed');
      }
    }
  },
  computed: {
    itemsLength() {
      return this.gallery.length;
    },
  },
};
</script>


<style lang="scss">
.CarouselModal {
  margin: 0;
  box-shadow: none;
  max-height: 100% !important;
  height: 100% !important;
}

.CarouselModal {
  .v-window__container,
  .v-window-item,
  .v-responsive,
  .v-responsive__content {
    height: 100% !important;
  }

  .v-carousel__prev {
    left: 5px;
    @supports (left: 5px) {
      left: calc(env(safe-area-inset-left) + 5px);
    }
  }

  .v-carousel__next {
    right: 5px;
    @supports (right: 5px) {
      right: calc(env(safe-area-inset-left) + 5px);
    }
  }
}

.CarouselModal {
  .slideGallery {
    position: relative;
    height: 100%;
    width: 100%;
  }

  .item_container {
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;

    &.lightbox-resp {
      height: 90%;
      width: 90%;
      left: 5%;
      top: 5%;
    }

    img,
    iframe {
      max-width: 100%;
      max-height: 100%;

      &.lightbox-resp {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    img {
      display: block;
      margin: 0 auto;
    }

    @supports (-webkit-overflow-scrolling: touch) {
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      &::before {
        z-index: 200;
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 1px;
        height: calc(100% + 2px);
        background: transparent;
        pointer-events: none;
      }
    }
  }

  .image_caption {
    position: absolute;
    left: 0;
    bottom: 0;
    color: #fff;
    text-align: center;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;

    > div {
      padding: 12px 0;
    }

    @supports (padding-bottom: env(safe-area-inset-bottom)) {
      padding-bottom: env(safe-area-inset-bottom);
    }
  }

  .image_wrap {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .video_container {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .video_wrap {
    width: 100%;
    position: relative;
    padding-bottom: 55.9%;
    transform: scale(0.9);

    &.lightbox-resp {
      padding-bottom: 0;
      width: 100%;
      height: 100%;
      transform: scale(1);
    }

    @supports (-webkit-overflow-scrolling: touch) {
      height: 100%;
      padding-bottom: 0;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      &::before {
        z-index: 200;
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 1px;
        height: calc(100% + 2px);
        background: transparent;
        pointer-events: none;
      }
    }
  }

  .closeButton {
    position: absolute;
    left: 8px;
    top: 8px;
    color: #fff;
    font-size: 1em;
    z-index: 1;
    padding: 5px;
    cursor: pointer;

    &::before {
      content: "";
      position: absolute;
      left: 5px;
      top: 0;
      height: 0px;
      width: 0px;
      border-radius: 20px;
      box-shadow: 0 0 45px 40px rgba(0, 0, 0, 0.2);
    }

    span {
      position: relative;
      text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
      vertical-align: middle;
      margin-left: 4px;
      top: 1px;
    }

    i {
      vertical-align: middle;
      position: relative;
    }

    @supports (top: env(safe-area-inset-top)) {
      top: calc(env(safe-area-inset-top) + 5px);
    }
  }
}

@media screen and (orientation: landscape) and (max-width: 960px) {
  .CarouselModal {
    .video_wrap {
      height: 100%;
      padding: 0;
    }
  }
}

@media screen and (orientation: landscape) {
  .CarouselModal {
    .image_caption.video {
      display: none;
    }

    .closeButton {
      left: 15px;
      top: 15px;
      @supports (left: 15px) {
        left: calc(env(safe-area-inset-left) / 4 + 15px);
        top: calc(env(safe-area-inset-left) / 4 + 15px);
      }
    }
  }
}
</style>
